import * as ReactRedux from 'react-redux'
import * as React from 'react'
import PropTypes from 'prop-types'

import { useI18n } from '@rushplay/i18n'

import * as Promotions from '../promotions'
import * as CombinedSelectors from '../combined-selectors'

import { FluidProvider } from './fluid-provider'

/**
 * This wrapper is workaround for fetching offers and
 * translations for Fluid bonuses, to avoid component
 * crash when offers or translations not available or mismatch.
 *
 * This wrapper should be used in the App component.
 * @param {*} props
 * @returns
 */
export function AppFluidProviderWrapper(props) {
  const campaignOffers = ReactRedux.useSelector(state =>
    Promotions.getOptedInDepositCampaigns(state.promotions, {
      dateNow: Date.now(),
    })
  )

  const depositOffers = ReactRedux.useSelector(state =>
    CombinedSelectors.getCalculatedOffers(state, {
      amountCents: 0, // Default to 0 to fetch all offers
    })
  )

  const isDepoitOfferAvaialble = depositOffers && depositOffers.length > 0

  const { translate } = useI18n()

  return (
    <FluidProvider
      translate={translate}
      offers={Object.values(campaignOffers)}
      depositOffers={isDepoitOfferAvaialble ? depositOffers : []}
    >
      {props.children}
    </FluidProvider>
  )
}

AppFluidProviderWrapper.propTypes = {
  children: PropTypes.node.isRequired,
}
